import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const diasSemana = [
    { label: "Lu", value: 1 },
    { label: "Ma", value: 2 },
    { label: "Mi", value: 3 },
    { label: "Ju", value: 4 },
    { label: "Vi", value: 5 },
    { label: "Sa", value: 6 },
    { label: "Do", value: 7 },
];
const diasMes = Array.from({ length: 31 }, (_, i) => ({ label: (i + 1).toString(), value: i + 1 }));
const meses = [
    { label: "Ene", value: 1 },
    { label: "Feb", value: 2 },
    { label: "Mar", value: 3 },
    { label: "Abr", value: 4 },
    { label: "May", value: 5 },
    { label: "Jun", value: 6 },
    { label: "Jul", value: 7 },
    { label: "Ago", value: 8 },
    { label: "Sep", value: 9 },
    { label: "Oct", value: 10 },
    { label: "Nov", value: 11 },
    { label: "Dic", value: 12 },
];

const RecurrenciaSelector = ({ values = {} }) => {
    const [frecuencia, setFrecuencia] = useState(values?.frecuencia || "semanal");
    const [cada, setCada] = useState(values?.cada || 1);
    const [fechaInicio, setFechaInicio] = useState(values?.fechaInicio || dayjs().format("YYYY-MM-DD"));
    const [ocurrencias, setOcurrencias] = useState(values?.ocurrencias || -1);
    const [weekdays, setWeekdays] = useState(values?.weekday || [1,2,3,4,5,6,7]);
    const [days, setDays] = useState(values?.day_of_month || [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]);
    const [months, setMonths] = useState(values?.month_of_year || [1,2,3,4,5,6,7,8,9,10,11,12]);
    const [status, setStatus] = useState(values?.status || "activo");

    const handleWeekdaysClick = (weekday) => {
        if (weekdays.includes(weekday)) {
            setWeekdays(weekdays.filter(d => d !== weekday));
        } else {
            setWeekdays([...weekdays, weekday]);
        }
    };

    const handleDaysClick = (day) => {
        if (days.includes(day)) {
            setDays(days.filter(d => d !== day));
        } else {
            setDays([...days, day]);
        }
    };

    const handleMonthsClick = (month) => {
        if (months.includes(month)) {
            setMonths(months.filter(d => d !== month));
        } else {
            setMonths([...months, month]);
        }
    };

        return (
            <div className="recurrencia-selector container-fluid">
                <input type="hidden" name="frecuencia" value={frecuencia} />
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="form-group" style={{marginBottom: 10, minHeight: 48}}>
                            <div className="d-flex align-items-center flex-wrap" style={{minHeight: 48, gap: 8}}>
                                <label className="form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Frecuencia:</label>
                                <div style={{display: 'flex', gap: 16, flexWrap: 'wrap'}}>
                                    <div style={{border: '1px solid #ced4da', borderRadius: 8, padding: '6px 18px', background: '#fff', display: 'flex', alignItems: 'center'}}>
                                        <label className="form-control-label" style={{display: 'flex', alignItems: 'center', gap: 4, margin: 0, fontSize: 17}}>
                                            <input type="radio" name="frecuenciaR" checked={frecuencia === "semanal"} onChange={() => setFrecuencia("semanal")} /> Semanal
                                        </label>
                                    </div>
                                    <div style={{border: '1px solid #ced4da', borderRadius: 8, padding: '6px 18px', background: '#fff', display: 'flex', alignItems: 'center'}}>
                                        <label className="form-control-label" style={{display: 'flex', alignItems: 'center', gap: 4, margin: 0, fontSize: 17}}>
                                            <input type="radio" name="frecuenciaR" checked={frecuencia === "mensual"} onChange={() => setFrecuencia("mensual")} /> Mensual
                                        </label>
                                    </div>
                                    <div style={{border: '1px solid #ced4da', borderRadius: 8, padding: '6px 18px', background: '#fff', display: 'flex', alignItems: 'center'}}>
                                        <label className="form-control-label" style={{display: 'flex', alignItems: 'center', gap: 4, margin: 0, fontSize: 17}}>
                                            <input type="radio" name="frecuenciaR" checked={frecuencia === "anual"} onChange={() => setFrecuencia("anual")} /> Anual
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="form-group" style={{marginBottom: 10, display: 'flex', alignItems: 'center', minHeight: 48, flexWrap: 'wrap', gap: 8}}>
                            <label className="form-control-label form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Cada:</label>
                            <input className="form-control" type="number" min={1} name="cada" value={cada} onChange={e => setCada(Number(e.target.value))} style={{width: 60, marginRight: 5}} />
                            {frecuencia === "semanal" ? "Semana" : frecuencia === "mensual" ? "Mes" : "Año"}
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        {frecuencia === "semanal" && (
                            <div className="form-group" style={{marginBottom: 10, minHeight: 48}}>
                                <div className="d-flex flex-wrap align-items-center" style={{gap: 8, marginTop: 5, flexWrap: 'wrap'}}>
                                    <label className="form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Los días:</label>
                                    <button type="button" className={weekdays.length === 7 ? "btn btn-primary" : "btn btn-outline-primary"} onClick={() => setWeekdays(diasSemana.map(d => d.value))} style={{borderRadius: '999px', padding: '2px 14px', minWidth: 0}}>Todos</button>
                                    {diasSemana.map(dia => (
                                        <button
                                            type="button"
                                            key={dia.value}
                                            className={weekdays.includes(dia.value) ? "btn btn-primary" : "btn btn-outline-primary"}
                                            onClick={() => handleWeekdaysClick(dia.value)}
                                            style={{borderRadius: '999px', padding: '2px 14px', minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                        >
                                            {dia.label}
                                        </button>
                                    ))}
                                </div>
                                {weekdays.map((day, index) => (
                                    <input key={`weekday-${day}`} type="hidden" name={`values[${index}][weekday]`} value={day} />
                                ))}
                            </div>
                        )}
                        {frecuencia === "anual" && (
                            <div className="form-group" style={{marginBottom: 10, minHeight: 48}}>
                                <div className="d-flex flex-wrap align-items-center" style={{gap: 8, marginTop: 5, flexWrap: 'wrap'}}>
                                    <label className="form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Los meses:</label>
                                    <button type="button" className={months.length === 12 ? "btn btn-primary" : "btn btn-outline-primary"} onClick={() => setMonths(meses.map(d => d.value))} style={{borderRadius: '999px', padding: '2px 14px', minWidth: 0}}>Todos</button>
                                    {meses.map(mes => (
                                        <button
                                            type="button"
                                            key={mes.value}
                                            className={months.includes(mes.value) ? "btn btn-primary" : "btn btn-outline-primary"}
                                            onClick={() => handleMonthsClick(mes.value)}
                                            style={{borderRadius: '999px', padding: '2px 14px', minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                        >
                                            {mes.label}
                                        </button>
                                    ))}
                                </div>
                                {months.map((month, index) => (
                                    <input key={`month-${month}`} type="hidden" name={`values[${index}][month]`} value={month} />
                                ))}
                            </div>
                        )}
                    </div>
                    {/* Now insert the mensual/anual conditional columns here, as siblings to the above columns */}
                    {frecuencia === "mensual" && (
                        <div className="col-12">
                            <div className="form-group" style={{marginBottom: 10, minHeight: 48}}>
                                <div className="d-flex flex-wrap align-items-center" style={{gap: 8, marginTop: 5, flexWrap: 'wrap'}}>
                                    <label className="form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Los días:</label>
                                    <button type="button" className={days.length === 31 ? "btn btn-primary" : "btn btn-outline-primary"} onClick={() => setDays(diasMes.map(d => d.value))} style={{borderRadius: '999px', padding: '2px 14px', minWidth: 0}}>Todos</button>
                                    {diasMes.map(dia => (
                                        <button
                                            type="button"
                                            key={dia.value}
                                            className={days.includes(dia.value) ? "btn btn-primary" : "btn btn-outline-primary"}
                                            onClick={() => handleDaysClick(dia.value)}
                                            style={{borderRadius: '999px', padding: '2px 14px', minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                        >
                                            {dia.label}
                                        </button>
                                    ))}
                                </div>
                                {days.map((day, index) => (
                                    <input key={`day-${day}`} type="hidden" name={`values[${index}][day_of_month]`} value={day} />
                                ))}
                            </div>
                        </div>
                    )}
                    {frecuencia === "anual" && (
                        <div className="col-12 col-md-6">
                            <div className="form-group" style={{marginBottom: 10, minHeight: 48}}>
                                <div className="d-flex flex-wrap align-items-center" style={{flexWrap: 'wrap', gap: 8}}>
                                    <label className="form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Día:</label>
                                    <input className="form-control" type="number" min={1} max={31} name="day_of_month" value={days[0]} onChange={e => setDays([Number(e.target.value)])} style={{width: 60, marginLeft: 5, marginRight: 10}} />
                                </div>
                            </div>

                            {months.map((month, index) => (
                                <input key={`day_of_month-${month}`} type="hidden" name={`values[${index}][day_of_month]`} value={days[0]} />
                            ))}
                        </div>
                    )}
                    <div className="col-12 col-md-6">
                        <div className="form-group" style={{marginBottom: 10, minHeight: 48}}>
                            <div className="d-flex align-items-center flex-wrap" style={{gap: 8, minHeight: 48}}>
                                <label className="form-control-label" style={{fontWeight: 700, fontSize: 14}}>Termina en:</label>
                                <label className="form-control-label"><input type="radio" name="ocurrencias" value="-1" checked={ocurrencias === -1} onChange={() => setOcurrencias(-1)} /> Nunca termina</label>
                                <label className="form-control-label" style={{marginLeft: 20}}><input type="radio" name="ocurrencias" value="1" checked={ocurrencias !== -1} onChange={() => setOcurrencias(1)} /> Termina en</label>
                                {ocurrencias !== -1 && (
                                    <input className="form-control" type="number" min={1} name="ocurrencias" value={ocurrencias} onChange={e => setOcurrencias(Number(e.target.value))} style={{width: 60, marginLeft: 5}} />
                                )}
                                {ocurrencias !== -1 && <span style={{marginLeft: 5}}>ocurrencia(s)</span>}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="form-group d-flex align-items-center flex-wrap" style={{marginBottom: 10, minHeight: 48, gap: 8}}>
                            <label className="form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Fecha de inicio:</label>
                            <input className="form-control" type="date" name="fecha_inicio" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} style={{maxWidth: 200}} />
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="form-group d-flex align-items-center flex-wrap" style={{marginBottom: 10, minHeight: 48, gap: 8}}>
                            <label className="form-control-label mr-2" style={{fontWeight: 700, fontSize: 14}}>Estado:</label>
                            <div className="form-check">
                                <select className="form-control" name="status" value={status} onChange={e => setStatus(e.target.value)}>
                                    <option value="activo">Activo</option>
                                    <option value="inactivo">Inactivo</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
};

export default RecurrenciaSelector;
